import React, { useState } from 'react';
import Main from '../../Main';
import { Col, Dropdown, Row } from 'react-bootstrap';
import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import '../../../assets/css/dashboard.scss'
import '../../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import { SbAddBtn, SbFilterBtn } from '../../Buttons/Buttons';
import Select from 'react-select';
import Download from '../../MainSection/Download/Download';
import AddRestDataSources from './AddRestDataSources';
import RestDataSourcesTable from './RestDataSourcesTable';
import "../../../assets/css/modulemanagement.scss";
import RestDataSourceCustomerTable from './RestDataSourceCustomerTable';
import { useNavigate } from 'react-router-dom';
import ViewRestDataSourceResponse from './ViewRestDataSourceResponse';

const statusOptions = [
    { value: "All", label: "All" },
    { value: "Pending", label: "Pending" },
    { value: "In-Process", label: "In-Process" },
    { value: "Resolved", label: "Resolved" },
    { value: "Re-Open", label: "Re-Open" },
    { value: "Cancel", label: "Cancel" },
]
const RestDataSources = () => {
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [showRestDataSourcesTable, setShowRestDataSourcesTable] = useState(false);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };
    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }

    const handleTotalCountClick = () => {
        setShowRestDataSourcesTable(true); // Show RestDataSourcesTable when total count is clicked
    };

    const handleBackToCustomerTable = () => {
        setShowRestDataSourcesTable(false); // Show RestDataSourceCustomerTable when back is clicked
        setShowErpDetails(false)
    };

    const navigate = useNavigate();
    const handleBack = () => {
        if (showRestDataSourcesTable || showERPDetails) {
            handleBackToCustomerTable(); // Show customer table on back
        } else {
            navigate(-1); // Navigate back if already in the customer table
        }
    };

    const [showERPDetails, setShowErpDetails] = useState(false)
    const handleSapClick = () => {
        // navigate('/settings/rest-data-sources-details')
        setShowErpDetails(true);
    }
    const handleOracleClick = () => {
        // navigate('/settings/rest-data-sources-details')
        setShowErpDetails(true);
    }

    const [openViewDetails, setOpenViewDetails] = useState(false)
    const handleOpenResponseModal = () => {
        setOpenViewDetails(!openViewDetails)
    }
    const handleCloseViewDetails = () => {
        setOpenViewDetails(false)
    }

    const handleAdd = () => {
        navigate('/rest-data-sources/add'); // Navigate to the Add page
    };

    // const handleAdd = () => {
    //     navigate('/rest-data-sources/add', {
    //         state: { showErpDetails: true }, // Pass a flag
    //     });
    // };    

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Settings / REST Data Sources (API)"
                        onBackClick={handleBack}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>REST Data Sources (API)</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                {(showRestDataSourcesTable || showERPDetails) && (
                                    <SbAddBtn btnName="Add"
                                        // onClickEffect={handleOpenModal}
                                        onClickEffect={handleAdd}
                                    />
                                )}
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            {!showRestDataSourcesTable && !showERPDetails ? (
                                <RestDataSourceCustomerTable
                                    handleOpenModal={handleOpenModal}
                                    handleViewDetails={handleViewDetails}
                                    handleTotalCountClick={handleTotalCountClick}
                                    handleOracleClick={handleOracleClick}
                                    handleSapClick={handleSapClick}
                                    handleAdd={handleAdd}
                                />
                            ) : (
                                <RestDataSourcesTable handleOpenResponseModal={handleOpenResponseModal} /> // Display RestDataSourcesTable
                            )}
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen &&
                <AddRestDataSources
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                />
            }
            {/* {showColumnFilterModal && (
                <CustomerFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                />
            )}
            {showValueFilterModal && (
                <CustomerValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )} */}
            {openViewDetails && (
                <ViewRestDataSourceResponse
                    openViewDetails={openViewDetails}
                    handleCloseViewDetails={handleCloseViewDetails}
                />
            )}
        </div >
    );
};

export default RestDataSources;